import { camelToPascal } from '@owner/casing';
import { removeDuplicates } from './common.js';
export const getFilters = ({ consumable, filters: customFilters = [], lists, sellable, }) => {
    const filters = [
        ...customFilters,
        {
            name: 'linkedToBrand',
            type: 'Boolean',
        },
        {
            name: 'linkedToPos',
            type: 'Boolean',
        },
        {
            name: 'brandLevel',
            type: 'Boolean',
        },
        {
            name: 'available',
            type: 'Boolean',
        },
        // Empty/existing list filters
        ...lists.map(({ name }) => ({
            name: `has${camelToPascal(name)}`,
            type: 'Boolean',
        })),
    ];
    if (consumable) {
        filters.push({
            name: 'glutenFree',
            type: 'Boolean',
        }, {
            name: 'vegetarian',
            type: 'Boolean',
        }, {
            name: 'alcohol',
            type: 'Boolean',
        });
    }
    if (sellable)
        filters.push({ name: 'taxable', type: 'Boolean' });
    return filters;
};
export const getSortKeys = ({ sortKeys: customSortKeys, sellable, }) => {
    const sortKeys = [
        ...customSortKeys,
        'name',
        'displayName',
        'createdAt',
        'updatedAt',
    ];
    if (sellable)
        sortKeys.push('amount', 'taxRate', 'metadata.totalRevenue', 'metadata.quantitySold');
    return removeDuplicates(sortKeys);
};
//# sourceMappingURL=filtering.js.map